module.exports = __webpack_public_path__ + "assets/5ee93e9e050d0762ea5c20796c18958d.svg";